module.exports = __webpack_public_path__ + "static/Coloring-Sheet-2-16fe9355b7b534a830f9b5504647854d.jpg";